module.exports = __webpack_public_path__ + "static/media/banner.c83d761b.jpg";